<template>
	<div>
		<b-overlay :show="isLoading">
			<b-card class="p-1" no-body>
				<b-row>
					<b-col class="d-flex justify-content-start">
						<strong class="d-flex align-items-center text-primary text-center">
							TOTAL DE TAREAS : {{ tasks.length }}
						</strong>
					</b-col>
					<b-col class="d-flex justify-content-end">
						<b-button
							class="d-inline text-nowrap"
							variant="outline-primary"
							@click="creationModal.show = !creationModal.show"
						>
							<FeatherIcon icon="PlusIcon" size="20" />
						</b-button>
					</b-col>
				</b-row>
			</b-card>
			<b-card no-body>
				<b-table-simple sticky-header="60vh">
					<b-thead class="text-center">
						<b-tr>
							<b-th>Día</b-th>
							<b-th>Nombre</b-th>
							<b-th>Producto</b-th>
							<b-th>Observaciones</b-th>
							<b-th>Activa</b-th>
							<b-th>Fecha de Creación</b-th>
						</b-tr>
					</b-thead>
					<b-tbody class="text-center">
						<b-tr v-for="tarea in tasks" :key="tarea.id">
							<b-td>{{ tarea.day }}</b-td>
							<b-td>{{ tarea.name }}</b-td>
							<b-td>{{ tarea.product_name }}</b-td>
							<b-td>{{ tarea.observation }}</b-td>
							<b-td>
								<b-badge pill :variant="'light-' + (tarea.is_active ? 'success' : 'danger')">
									{{ tarea.is_active ? "SÍ" : "NO" }}
								</b-badge>
								<b-form-checkbox
									v-model="tarea.is_active"
									:true-value="1"
									:false-value="0"
									name="check-button"
									switch
									:disabled="tarea.status == 'OCUPADA'"
									class="mt-1 text-center"
									@change="updateStatus(tarea)"
									style="margin-left: 0.5rem"
								/>
							</b-td>
							<b-td>
								{{ tarea.created_at | myGlobalDayWithHour }}
							</b-td>
						</b-tr>
						<b-tr v-if="tasks.length == 0">
							<b-td colspan="6">
								<p class="mb-0">No hay registros por mostrar</p>
							</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</b-card>
		</b-overlay>
		<b-modal
			centered
			v-model="creationModal.show"
			title="Crear tarea"
			@hidden="handleHidden"
			size="sm"
			no-close-on-backdrop
		>
			<ValidationObserver ref="form">
				<b-form-group label="Seleccionar Día:">
					<div class="d-flex justify-content-center align-items-center mt-1">
						<feather-icon
							@click="creationModal.day > 0 ? creationModal.day-- : creationModal.day"
							icon="MinusCircleIcon"
							size="50"
							class="cursor-pointer"
							:class="{ 'text-danger': creationModal.day == 0, 'text-success': creationModal.day > 0 }"
						/>
						<div class="container-number bg-primary">
							<p class="mb-0 font-small-4 d-flex justify-content-center align-items-center">
								{{ creationModal.day }}
							</p>
						</div>

						<feather-icon
							@click="creationModal.day++"
							icon="PlusCircleIcon"
							size="50"
							class="cursor-pointer text-success"
						/>
					</div>
				</b-form-group>
				<div class="text-danger my-1">*Día 0 es el día de nacimiento</div>
				<ValidationProvider rules="required" v-slot="{ errors }">
					<b-form-group label="Nombre de la tarea:">
						<b-form-input
							id="name"
							v-model="creationModal.name"
							:state="errors.length > 0 ? false : null"
							placeholder="Nombre de la tarea"
						/>
						<b-form-invalid-feedback :state="errors.length > 0 ? false : null">
							{{ errors[0] }}
						</b-form-invalid-feedback>
					</b-form-group>
				</ValidationProvider>
				<b-form-group label="Producto:">
					<v-select
						v-model="creationModal.product_id"
						:options="products"
						label="name"
						:reduce="(option) => option.id"
						placeholder="Seleccionar Producto"
					/>
				</b-form-group>
				<b-form-group label="Observaciones:">
					<b-form-textarea
						id="observations"
						v-model="creationModal.observation"
						placeholder="Observaciones"
					/>
				</b-form-group>
			</ValidationObserver>
			<template #modal-footer>
				<b-button variant="success" @click="createTask">Crear</b-button>
			</template>
		</b-modal>
	</div>
</template>

<script>
import TareasService from "@/views/brain/encaste/views/tareas/services/tareas.service.js"
import WarehouseService from "@/views/amg/management/views/warehouse/services/warehouse.service.js"
export default {
	name: "TareasView",
	data: () => ({
		isLoading: false,
		tasks: [],
		creationModalBase: {
			show: false,
			day: 0,
			name: "",
			observation: "",
			id: null,
			product_id: null,
		},
		creationModal: {
			show: false,
			day: 0,
			name: "",
			observation: "",
			id: null,
			product_id: null,
		},
		products: [],
	}),
	methods: {
		handleHidden() {
			this.creationModal = { ...this.creationModalBase }
		},
		async getProducts() {
			this.isPreloading()
			try {
				const { data } = await WarehouseService.getProductsWithStock()
				this.products = data
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async updateStatus(task) {
			const { isConfirmed } = await this.showConfirmSwal({
				title: `¿Estás seguro de que quieres ${task.is_active ? "activar" : "desactivar"} a la ${task.name}?`,
				text: "",
			})
			if (!isConfirmed) {
				task.is_active = !task.is_active
				return
			}
			this.isPreloading()
			try {
				const { message } = await TareasService.switchActive(task.id)
				this.getTasks()
				this.showSuccessToast(message)
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},

		async getTasks() {
			this.isPreloading()
			try {
				const { data } = await TareasService.getTasks()
				this.tasks = data.map((reason) => ({
					...reason,
					is_active: reason.is_active === 1 ? true : false,
				}))
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async createTask() {
			const validated = await this.$refs.form.validate()
			if (!validated) return
			const { isConfirmed } = await this.showConfirmSwal({
				title: `¿Estás seguro de que quieres crear la tarea?`,
				text: "",
			})
			if (!isConfirmed) return

			this.isPreloading()
			try {
				const res = await TareasService.storeTask({
					...this.creationModal,
				})
				this.getTasks()
				this.handleHidden()
				this.showSuccessToast(res.message)
			} catch (error) {
				console.log(error)
				this.showToast("danger", "top-right", "Error", "AlertCircleIcon", error.message)
			} finally {
				this.isPreloading(false)
			}
		},
	},
	created() {
		this.getProducts()
		this.getTasks()
	},
}
</script>
<style lang="scss" scoped>
.container-number {
	height: 50px;
	width: 50px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	margin: 0 0.1rem;
	p {
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bolder !important;
	}
}
</style>
